import type { Project } from '@/models/project';

export interface CombinedUser {
    user_id: number;
    firstname: string;
    lastname: string;
    email: string;
    isExternalUser: boolean;
    isMsUser: boolean;
    unique?: string;
}

export const getCombinedProjectUsers = (project?: Project): CombinedUser[] => {
    if (!project || !project.users) {
        return [];
    }

    let users: CombinedUser[] = [];

    users = users.concat(
        project.external_users.map((externalUser) => {
            return {
                user_id: externalUser.id,
                firstname: externalUser.firstname,
                lastname: externalUser.lastname,
                isExternalUser: true,
                isMsUser: false,
                email: externalUser.email,
                unique: externalUser.id + '-1',
            } as CombinedUser;
        })
    );

    // If project is connected with Microsoft Teams we're adding ms_users
    if (project.ms_integration !== null) {
        users = users.concat(
            project.ms_users!.map((msUser) => {
                return {
                    user_id: msUser.id,
                    firstname: msUser.firstname,
                    lastname: msUser.lastname,
                    email: msUser.email,
                    isExternalUser: true,
                    isMsUser: true,
                    unique: msUser.id + '-2',
                } as CombinedUser;
            })
        );
    }

    users = users.concat(
        project.users.map((user) => {
            return {
                user_id: user.id,
                firstname: user.firstname,
                lastname: user.lastname,
                isExternalUser: false,
                isMsUser: false,
                email: user.email,
                unique: user.id + '-0',
            } as CombinedUser;
        })
    );

    return users;
};
